export const reverseMessages = (messages: Array<any>) => {
    if(messages.length === 0) return []
  return [...messages].sort(
    (a, b) => new Date(a.sent_at).getTime() - new Date(b.sent_at).getTime()
  );
};

